<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .stats {
    display: flex;
    gap: 1rem;
    margin: 2.125rem 0;

    .stat-card {
      background: #fff;
      padding: utils.in_rem(16px);
      border-radius: utils.in_rem(16px);
      width: 250px;

      .label-with-tooltip {
        display: flex;
        justify-content: space-between;
      }

      h2 {
        margin: utils.in_rem(12px) 0px;
      }
    }
  }
</style>

<script>
  export let stats;
</script>

<div class="stats">
  <div class="stat-card">
    <h3>DATA FIELDS</h3>
    <h2>{stats.dataFields.value}</h2>
    <span>{stats.dataFields.label}</span>
  </div>
  <div class="stat-card">
    <div class="label-with-tooltip">
      <span>CONTACTS</span>
      <!-- <IconScale class="fa-circle-info" size="xs" placement="top">
        <span slot="tooltip"
          >Number of contacts refreshed since {stats.contacts.oldestDate}</span
        >
      </IconScale> -->
    </div>
    <h2>{stats.contacts.value}</h2>
    <span>{stats.contacts.label}</span>
  </div>
</div>
